import React, {
    PropTypes,
} from 'react';
import {Table} from 'react-bootstrap';
import {connect} from 'react-redux';
import axios from 'axios';
import {apibase} from '../../api/api';

class DocsDetails extends React.Component {
    static propTypes = {
        documentsData: PropTypes.array.isRequired,
        type: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired
    };

    render() {
        const {documentsData, type, id} = this.props;
        const token = axios.defaults.headers.common['Authorization'];
        if (documentsData.length === 0) {
            return <div>Документи відсутні</div>;
        }
        const rows = documentsData.map((detail) => {
            return <div>
                {detail.documents.map((doc) => {
                    return <Table condensed className="mt15 my-table">
                        <thead>
                        <tr>
                            <th colSpan={2} style={{textAlign: 'center'}}>{detail.documentTypeName} {doc.serial}{doc.serialNumber}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {doc.dateGiven ?
                            <tr>
                                <td style={{width: '100px'}}>Видано</td>
                                <td>{doc.dateGiven}</td>
                            </tr> : ''
                        }
                        {doc.dateValid ?
                        <tr>
                            <td>Дійсно до</td>
                            <td>{doc.dateValid}</td>
                        </tr> : ''
                        }
                        {doc.description ?
                        <tr>
                            <td>Примітки</td>
                            <td>{doc.description}</td>
                        </tr> : ''
                        }

                        <tr>
                            <td>Завантажити</td>
                            <td>
                                <a href={apibase + '/v1/documents/file?object_type=' + type + '&object_id=' + id + '&document_id=' +
                                doc.documentId + '&Authorization=' + token}
                                   className="btn btn-default btn-block"
                                   style={{whiteSpace: "normal"}}
                                   target="_blank"
                                >
                                    {doc.fileName ? doc.fileName : 'Файл'}
                                </a>
                            </td>
                        </tr>
                        </tbody>
                    </Table>
                })}
            </div>
        });
        return (
            <div>
                {rows}
            </div>
        );
    };
}

function mapStateToProps() {
    return {};
}

export default connect(mapStateToProps, {})(DocsDetails);




/** WEBPACK FOOTER **
 ** ./src/modules/documents/DocsDetails.js
 **/